import React from 'react'

class DisabledHorizontalMenuIconComponent extends React.Component {
  render () {
    return (
      <div style={styles.disabledSection}>
        <button style={styles.button}
          onClick={this.props.onClick}>
          <img src={this.props.img} alt='true' style={styles.icon} /><br />
          <span style={styles.disabledLabel}>{this.props.label}</span>
        </button>
      </div>
    )
  }
}

const styles = {
  disabledSection: {
    width: '112px',
    height: '68px',
    float: 'left'
  },
  icon: {
    marginTop: '1px',
    width: '38px',
    height: '40px'
  },
  button: {
    cursor: 'pointer',
    backgroundColor: 'Transparent',
    border: 'none',
    width: '112px',
    height: '68px',
    outline: 'none'
  },
  disabledLabel: {
    fontSize: '10px',
    fontWeight: 500,
    fontStyle: 'normal',
    color: '#A6B9C8'
  }
}

export default DisabledHorizontalMenuIconComponent
